import {IHttpService} from "angular";
import {IsoDate} from "../../pseudo-types/DateTypes";
import {ContractNoteRecords} from "../types/ContractNoteRecord";
import {AccountId} from "../types/AccountRecord";

export class ContractNotesService {

    public static readonly id = "contractNotesService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {
    }

    public async list(accountId: AccountId,
                      fromDate: IsoDate,
                      toDate: IsoDate | null): Promise<ContractNoteRecords> {
        const url = `/tradefloor/api/contract-notes/${accountId}`;
        const params = {fromDate, toDate};
        const response = await this.$http.get<ContractNoteRecords>(url, {params});
        return response.data;
    }
}
